import React from 'react'
import EmptyStyle from '../../components/emptyStyles/emptyStyle'
import { Typography } from '@mui/material'
import CustomisedButton from '../../components/button/button'
import { useNavigate } from 'react-router-dom';

export default function NotFountNew({ message = 'مشکلی رخ داده است', description = 'صفحه ای که به دنبال آن هستید یافت نشد!' }: { message: string, description: string }) {
    const navigate = useNavigate();
    return (
        <div className="w-full h-full flex flex-col justify-center items-center gap-20 p-20">
            <div>
                <EmptyStyle text={message} icon={<img src="/images/notFound.png" />} emphasisedWords={[]} emphasisedWordsColor="" >
                    <Typography sx={{ color: "var(--primary-text-color)" }} style={{ fontSize: ".9rem" }}>{description}</Typography>
                </EmptyStyle>
            </div>
            <div className="w-full">

                <CustomisedButton title="صفحه اصلی" disable={false} onClick={() => navigate('/')} type="button" />
            </div>
        </div>
    )
}
